import { useMutation } from '@tanstack/react-query';
import { updateUserHabitSortMode } from 'shared/services/backend-api';
import { HabitSortingMode } from 'shared/types/sorting-mode';

export const useUpdateHabitSortModeMutation = () =>
  useMutation({
    mutationFn: async (sortMode: HabitSortingMode) =>
      updateUserHabitSortMode(sortMode),
  });
